// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientFinderPatientResponseName {
    'firstname'?: string;
    'lastname'?: string;
    'middlename'?: string;
    'rank'?: string;
    'source'?: string;
    'type'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientFinderPatientResponseName>> = [
        {
            "name":     "firstname",
            "baseName": "firstname",
            "type":     "string"
        },
        {
            "name":     "lastname",
            "baseName": "lastname",
            "type":     "string"
        },
        {
            "name":     "middlename",
            "baseName": "middlename",
            "type":     "string"
        },
        {
            "name":     "rank",
            "baseName": "rank",
            "type":     "string"
        },
        {
            "name":     "source",
            "baseName": "source",
            "type":     "string"
        },
        {
            "name":     "type",
            "baseName": "type",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PatientFinderPatientResponseName.attributeTypeMap;
    }
}
